var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-select',{attrs:{"width":"55px"},on:{"change":_vm.handleChange},model:{value:(_vm.selectedHour),callback:function ($$v) {_vm.selectedHour=$$v},expression:"selectedHour"}},_vm._l((_vm.options),function(item,index){return _c('vs-select-item',{key:index,attrs:{"value":item.value,"text":item.text}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }